import { axios } from '@/utils/request'
const api = {
  source: '/finance/customerStatement',
  get:'/finance/statementRreceiver',
  template:'/finance/statement'
  // /finance/enterpriseStatement/queryAlreadyPay /finance/enterpriseStatement/refund 退款

}
// 
// 获取需要支付金额
export function getQueryNeedPay (parameter) {
  return axios({
    url: api.source + '/queryNeedPay',
    method: 'get',
    params: parameter
  })
}
// 财务查看主对账单详情过滤
export function getdetailFilte (parameter) {
  return axios({
    url: '/finance/customerStatement/detailFilte',
    method: 'get',
    params: parameter
  })
}
export function getupdateExpectDate (parameter) {
  return axios({
    url: api.source + '/updateExpectDate',
    method: 'get',
    params: parameter
  })
}
export function getexportList (parameter) {
  return axios({
    url: '/finance/customerStatement/detailExport',
    method: 'get',
    params: parameter,
    responseType: 'arraybuffer',
    headers: {
      'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }
  })
}
export function getsubDetailExport (parameter) {
  return axios({
    url: '/finance/customerStatement/subDetailExport',
    method: 'get',
    params: parameter,
    responseType: 'arraybuffer',
    headers: {
      'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }
  })
}
export function getupdateSettleAmount (parameter) {
  return axios({
    url:  '/finance/customerStatement/updateSettleAmount',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 确认修改
export function getconfirmAmount (parameter) {
  return axios({
    url: '/finance/customerStatement/confirmAmount',
    method: 'GET',
    params: parameter,
  })}
export function gettoBeConfirmedAmount (parameter) {
  return axios({
    url:  '/finance/customerStatement/toBeConfirmedAmount',
    method: 'get',
    params: parameter
  })
}
// 获取需要已支付金额
export function getAlreadyPay (parameter) {
  return axios({
    url: api.source + '/queryAlreadyPay',
    method: 'get',
    params: parameter
  })
}

// 提交 分单
export function getSeparateList (parameter) {
  return axios({
    url: api.source + '/separateStatement',
    method: 'GET',
    params: parameter,
  })}
// 企业生成对账单
export function getEnterpriseSettleList (parameter) {
  return axios({
    url: api.source + '/settle',
    method: 'post',
    data: parameter,
    timeout: 600000,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// /finance/enterpriseStatement/refund 退款
export function getRefundList (parameter) {
  return axios({
    url: api.source + '/refund ',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 账单移除
export function removeList (parameter) {
  return axios({
    url: api.source + '/statementOrder/remove',
    method: 'GET',
    params: parameter,
  })}
// 获取企业对账单接收人
export function getStatementRreceiver (parameter) {
  return axios({
    url: api.get + '/get',
    method: 'GET',
    params: parameter,
  })}
export function getTemplate (parameter) {
  return axios({
    url: api.template + '/template/get',
    method: 'GET',
    params: parameter,
  })}
export const sourceExport = api.source + '/export'